export const API_ENDPOINT = process.env.NODE_ENV === 'production' ? "https://app.wayboz.com" : "http://localhost:3001";